import React from 'react'
import { RawFoodSubscriptionRoot, SignupHeader } from './RawFoodSubscription.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Layout } from 'components/Layout'
import { useObserver } from 'hooks/useObserver'
import { Header } from 'components/Header'
import { Footer } from 'components/Footer'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { NeverAgain } from './components/NeverAgain'
import { Shipping } from './components/Shipping'
import { SmartSubscription } from './components/SmartSubscription'
import { TheDifference } from './components/TheDifference'
import { HowItWorks } from 'features/Home/components/HowItWorks'
import { defaultSteps } from 'features/Home/components/HowItWorks/steps'
import { Hero } from './components/Hero'

type RawFoodSubscriptionProps = {}

export const RawFoodSubscription: React.FC<RawFoodSubscriptionProps> = ({}) => {
  const { t } = useTranslation()

  const selector = 'button.cta'

  const hideCta = useObserver({ selector })

  const header = <Header />

  const steps = defaultSteps
  steps[0].description = 'raw-food-subscription:how-it-works.step-1-description'
  steps[1].description = 'raw-food-subscription:how-it-works.step-2-description'

  return (
    <RawFoodSubscriptionRoot>
      <Layout header={header} hideCTA={hideCta}>
        <Hero />
        <NeverAgain />
        <HowItWorks title='raw-food-subscription:how-it-works.title' cta='raw-food-subscription:cta' steps={steps} variant="secondary" />
        <Shipping />
        <SmartSubscription />
        <TheDifference />
        <CtaFooter cta='raw-food-subscription:cta'>
          <SignupHeader className='d-only'>{t('raw-food-subscription:signup.title')}</SignupHeader>
          <SignupHeader className='m-only'>{t('raw-food-subscription:signup.title-m')}</SignupHeader>
        </CtaFooter>
        <Footer />
      </Layout>
    </RawFoodSubscriptionRoot>
  )
}
